import { toast } from "react-toastify";
import { pingNetwork } from "../api/auth";
import { convertOrderToSale } from "../api/orders";
import { saveSale } from "../api/sales";
import {
  addNewOrder,
  removeOfflineOrder,
} from "../redux/features/orders-slice";
import { updateExistingProduct } from "../redux/features/products-slice";
import { addNewSale, removeOfflineSale } from "../redux/features/sales-slice";
import { storage } from "./storage";

export async function isActuallyOnline(ping) {
  if (!navigator.onLine) return false;

  try {
    if(ping){
      await pingNetwork();
    }
    return true;
  } catch {
    return false;
  }
}

export async function transferQueuedData(dispatch) {
  let offlineSales = await storage.get("offlineSales");
  offlineSales = offlineSales ? JSON.parse(offlineSales) : [];

  let offlineOrders = await storage.get("offlineOrders");
  offlineOrders = offlineOrders ? JSON.parse(offlineOrders) : [];

  let completed = false;

  for (const sale of offlineSales) {
    try {
      if (sale?.isConvert) {
        const response = await convertOrderToSale(sale?.id, sale);
        if (response.data?.success) {
          completed = true;
          dispatch(removeOfflineSale({ sale: sale }));
          dispatch(addNewSale({ sale: response.data?.sale }));
          if (response.data?.updated_products?.length > 0) {
            dispatch(
              updateExistingProduct({
                products: response.data?.updated_products,
              })
            );
          }
        }
      } else {
        const response = await saveSale(sale);
        if (response.data?.success) {
          completed = true;
          dispatch(removeOfflineSale({ sale: sale }));
          dispatch(addNewSale({ sale: response.data?.sale }));
          if (response.data?.updated_products?.length > 0) {
            dispatch(
              updateExistingProduct({
                products: response.data?.updated_products,
              })
            );
          }
        }
      }
    } catch (error) {
      completed = true;
      if (error?.response?.data?.message === "This sale is not an order.") {
        dispatch(removeOfflineSale({ sale: sale }));
      } else if (
        error?.response?.data?.message ===
        "This offline sale/order was already created."
      ) {
        dispatch(removeOfflineSale({ sale: sale }));
      } else {
        completed = false;
      }
    }
  }

  for (const sale of offlineOrders) {
    try {
      const response = await saveSale(sale);
      if (response.data?.success) {
        completed = true;
        dispatch(removeOfflineOrder({ order: sale }));
        dispatch(addNewOrder({ order: response.data?.sale }));
        if (response.data?.updated_products?.length > 0) {
          dispatch(
            updateExistingProduct({
              products: response.data?.updated_products,
            })
          );
        }
      }
    } catch (error) {
      if (
        error?.response?.data?.message ===
        "This offline sale/order was already created."
      ) {
        completed = true;
        dispatch(removeOfflineOrder({ order: sale }));
      } else {
        completed = false;
      }
    }
  }

  if (completed) {
    toast.dismiss(); toast.success("Offline sales/orders synced successfully.");
  }
}
